module.exports = __webpack_public_path__ + "img/path-28.0f7866c0.svg";